import(/* webpackMode: "eager", webpackExports: ["ReviewsPageHeader"] */ "/app/src/app/(ru)/(help-pages)/reviews-rules/ui/page-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageWrapper"] */ "/app/src/components/layout/page-wrapper/page-wrapper.tsx");
